import { LocalStorage } from '../../../../shared/utils';
import localization from '../../../../shared/strings';
import { showDialog } from '../../../dialog';

const dialogL10n = localization.PRODUCT_INFO.aggregated.dialogs;

export const AGGREGATED_CLEAR_FIELD_SKIP_KEY = 'picsio.aggregatedClearFieldSkipConfirm';
export const AGGREGATED_UPDATE_FIELD_SKIP_KEY = 'picsio.aggregatedUpdateFieldSkipConfirm';
export const AGGREGATED_ATTACH_KEYWORD_SKIP_KEY = 'picsio.aggregatedAttachKeywordSkipConfirm';
export const AGGREGATED_DETACH_KEYWORD_SKIP_KEY = 'picsio.aggregatedDetachKeywordSkipConfirm';

const getApplicableCount = (field) => field?.stats?.applicableCount || 0;

const isSingleRecordUpdate = (field) => getApplicableCount(field) <= 1;

const showAggregatedFieldDialog = ({
  storageKey,
  title,
  text,
  textBtnOk = dialogL10n.btnConfirm,
  onConfirm,
  onCancel,
}) => {
  if (LocalStorage.get(storageKey)) {
    onConfirm();
    return;
  }

  showDialog({
    title,
    text,
    textBtnCancel: dialogL10n.btnCancel,
    textBtnOk,
    checkbox: { value: false, label: dialogL10n.dontShowAgain },
    onOk: (state) => {
      if (state.checkbox) {
        LocalStorage.set(storageKey, true);
      }
      onConfirm();
    },
    onCancel: () => onCancel?.(),
    onClose: () => onCancel?.(),
  });
};

export const showAggregatedClearDialog = ({ fieldLabel, field, onConfirm, onCancel }) => {
  if (isSingleRecordUpdate(field)) {
    onConfirm();
    return;
  }

  showAggregatedFieldDialog({
    storageKey: AGGREGATED_CLEAR_FIELD_SKIP_KEY,
    title: dialogL10n.clearFieldTitle(fieldLabel),
    text: dialogL10n.clearFieldText,
    onConfirm,
    onCancel,
  });
};

export const showAggregatedUpdateDialog = ({
  fieldLabel,
  field,
  onConfirm,
  onCancel,
}) => {
  if (isSingleRecordUpdate(field)) {
    onConfirm();
    return;
  }

  const totalCount = getApplicableCount(field);

  showAggregatedFieldDialog({
    storageKey: AGGREGATED_UPDATE_FIELD_SKIP_KEY,
    title: dialogL10n.updateFieldTitle(fieldLabel),
    text: dialogL10n.updateFieldText(totalCount),
    textBtnOk: dialogL10n.btnUpdate,
    onConfirm,
    onCancel,
  });
};

export const showAggregatedAttachKeywordDialog = ({
  keywordName,
  field,
  onConfirm,
  onCancel,
}) => {
  if (isSingleRecordUpdate(field)) {
    onConfirm();
    return;
  }

  const totalCount = getApplicableCount(field);

  showAggregatedFieldDialog({
    storageKey: AGGREGATED_ATTACH_KEYWORD_SKIP_KEY,
    title: dialogL10n.attachKeywordTitle(keywordName),
    text: dialogL10n.attachKeywordText(totalCount),
    textBtnOk: dialogL10n.btnAdd,
    onConfirm,
    onCancel,
  });
};

export const showAggregatedDetachKeywordDialog = ({
  field,
  onConfirm,
  onCancel,
}) => {
  if (isSingleRecordUpdate(field)) {
    onConfirm();
    return;
  }

  const totalCount = getApplicableCount(field);

  showAggregatedFieldDialog({
    storageKey: AGGREGATED_DETACH_KEYWORD_SKIP_KEY,
    title: dialogL10n.detachKeywordTitle,
    text: dialogL10n.detachKeywordText(totalCount),
    textBtnOk: dialogL10n.btnConfirm,
    onConfirm,
    onCancel,
  });
};
